var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlankFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 19H0.25C0.25 19.4142 0.585786 19.75 1 19.75L1 19ZM15 19V19.75C15.4142 19.75 15.75 19.4142 15.75 19H15ZM1 1V0.25C0.585786 0.25 0.25 0.585786 0.25 1L1 1ZM10 1L10.5303 0.46967C10.3897 0.329018 10.1989 0.25 10 0.25V1ZM15 6H15.75C15.75 5.80109 15.671 5.61032 15.5303 5.46967L15 6ZM1 19.75H15V18.25H1V19.75ZM0.25 1V19H1.75V1H0.25ZM9 0.25H1V1.75H9V0.25ZM15.75 19V7H14.25V19H15.75ZM9 1.75H10V0.25H9V1.75ZM15.75 7V6H14.25V7H15.75ZM15.5303 5.46967L10.5303 0.46967L9.46967 1.53033L14.4697 6.53033L15.5303 5.46967ZM8.25 1V5H9.75V1H8.25ZM8.25 5C8.25 5.74392 8.61441 6.42507 9.09467 6.90533C9.57493 7.38559 10.2561 7.75 11 7.75V6.25C10.7439 6.25 10.4251 6.11441 10.1553 5.84467C9.88559 5.57493 9.75 5.25608 9.75 5H8.25ZM11 7.75H15V6.25H11V7.75Z",
    fill: "#2AB7F8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankFile);
export default __webpack_public_path__ + "static/media/blank-file.ed15ba8de502dd2bf5c3eec0f44fdbd0.svg";
export { ForwardRef as ReactComponent };